import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import Login from '../../components/login/login';
import BrandedLogin from '../../components/branded-login/branded-login';

const Authentication = ({
  requiresAuth,
  authRoleRequired,
  onSuccess,
  isSignedIn,
  loginModalCopyOverride,
  loginPageCopyOverride,
  roles,
  children,
  // branded Login
  useBrandedLogin,
  brandedBackgroundImage,
  brandedIcon,
  brandedTitle,
  brandedSubtitle,
  customCtaText,
  topLoginBoxColor,
  bottomLoginBoxColor,
  topLoginBoxMargin,
  bottomLoginBoxMargin,
}) => {
  const isEmployee = _.includes(roles, 'nerdwallet/employee');
  const hasAuth = isEmployee || _.includes(roles, `${authRoleRequired}`);

  const LoginComponent = useBrandedLogin ? BrandedLogin : Login;

  return requiresAuth && !hasAuth ? (
    <LoginComponent
      onSuccess={onSuccess}
      isSignedIn={isSignedIn}
      loginModalCopyOverride={loginModalCopyOverride}
      loginPageCopyOverride={loginPageCopyOverride}
      // branded Login
      brandedBackgroundImage={brandedBackgroundImage}
      brandedIcon={brandedIcon}
      brandedTitle={brandedTitle}
      brandedSubtitle={brandedSubtitle}
      customCtaText={customCtaText}
      topLoginBoxColor={topLoginBoxColor}
      bottomLoginBoxColor={bottomLoginBoxColor}
      topLoginBoxMargin={topLoginBoxMargin}
      bottomLoginBoxMargin={bottomLoginBoxMargin}
    />
  ) : (
    children
  );
};

Authentication.propTypes = {
  requiresAuth: PropTypes.bool,
  authRoleRequired: PropTypes.string,
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginModalCopyOverride: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
  roles: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  // branded Login
  useBrandedLogin: PropTypes.bool,
  brandedBackgroundImage: PropTypes.string,
  brandedIcon: PropTypes.string,
  brandedTitle: PropTypes.string,
  brandedSubtitle: PropTypes.string,
  customCtaText: PropTypes.string,
  topLoginBoxColor: PropTypes.string,
  bottomLoginBoxColor: PropTypes.string,
  topLoginBoxMargin: PropTypes.number,
  bottomLoginBoxMargin: PropTypes.number,
};

const AuthenticationWrapped = connect((state) => ({
  isSignedIn: _.get(state, 'identity.isSignedIn', false),
  roles: _.get(state, 'identity.current.roles'),
}))(Authentication);

AuthenticationWrapped.displayName = 'Wrapped Authentication';

export default AuthenticationWrapped;
